import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { GoogleLogin, GoogleMobileLogin } from '../../assets';
import SocialLoginBtn from './SocialLoginBtn';
import { SocialLoginButtonsProps, SocialLoginPlatformEnum } from './type';

export default function GoogleLoginBtn({
  afterSocialLoginSuccess,
  dataSocial,
  variant = 'legacy',
  recentLogin,
}: SocialLoginButtonsProps) {
  const isRecent = variant === 'draft' && recentLogin === dataSocial;
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await axios.get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
              Accept: 'application/json',
            },
          }
        );
        if (res.status === 200) {
          afterSocialLoginSuccess({
            type: SocialLoginPlatformEnum.GOOGLE,
            socialId: res.data.id,
            email: res.data.email,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    onError: () => {
      console.log('login fail');
    },
  });
  return (
    <div
      data-social={dataSocial}
      className={isRecent ? 'login-social-wrap--recent' : undefined}
    >
      <SocialLoginBtn
        onClick={() => login()}
        backgroundColor="bg-white"
        fontColor="text-[#121212]"
        additionalStyle={variant === 'draft' ? undefined : 'border md:border-gray-400 border-gray-300'}
        icon={
          variant === 'draft' ? (
            <GoogleLogin width={24} height={24} />
          ) : (
            <>
              <GoogleLogin className="hidden md:block" width={24} height={24} />
              <GoogleMobileLogin className="block md:hidden" />
            </>
          )
        }
        text="google"
        variant={variant}
      />
    </div>
  );
}
